async function initServiceDetailMap() {
  const mapElem = document.querySelector<HTMLElement>('[data-portal-service-detail-map]');

  if (!mapElem) return;

  const lat = Number.parseFloat(mapElem.dataset.mapLat);
  const lng = Number.parseFloat(mapElem.dataset.mapLng);
  const parsedZoom = Number.parseInt(mapElem.dataset?.mapZoom);
  const zoom = Number.isNaN(parsedZoom) ? 15 : parsedZoom;
  const title = mapElem.dataset.mapMarkerTitle ?? 'Service Location';
  const mapId = mapElem.dataset.mapId;

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

  // 'as' syntax MUST be used to infer the type with these
  // new import functions.
  try {
    const { Map: GoogleMap } = (await google.maps.importLibrary('maps')) as google.maps.MapsLibrary;
    const { AdvancedMarkerElement } = (await google.maps.importLibrary('marker')) as google.maps.MarkerLibrary;

    const map = new GoogleMap(mapElem, {
      center: { lat, lng },
      zoom,
      mapId,
      disableDefaultUI: true,
    });

    // Add marker at the map center
    const markerContent = document.createElement('div');
    markerContent.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="28" viewBox="0 0 21 28" fill="none">
        <path d="M10.5 0C16.299 2.59324e-07 21 4.73094 21 10.5664C20.9997 18.4909 11.55 28 10.5 28C9.45002 28 0.000292826 18.4909 0 10.5664C0 4.73094 4.70101 0 10.5 0ZM10.5664 6.34375C8.81577 6.34375 7.39648 7.76303 7.39648 9.51367C7.39654 11.2643 8.8158 12.6836 10.5664 12.6836C12.317 12.6835 13.7363 11.2642 13.7363 9.51367C13.7363 7.76307 12.317 6.34381 10.5664 6.34375Z" fill="#1D3028"/>
      </svg>
    `;

    new AdvancedMarkerElement({
      map,
      position: { lat, lng },
      content: markerContent,
      title,
    });
  } catch (e) {
    mapElem.style.display = 'none';
    console.error('Failed to init map: ', e);
  }
}

// Auto-initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initServiceDetailMap);
} else {
  initServiceDetailMap();
}
